import { Switch, styled } from "@mui/material";

import BPSwitch from "../../../assets/images/BPSwitchBefore.svg";
import BPSwitchAfter from "../../../assets/images/BPSwitchAfter.svg"

const MaterialUISwitch = styled(Switch)(() => ({
  width: 64,
  height: 32,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url(${BPSwitchAfter})`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url(${BPSwitch})`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    borderRadius: 25,
  },
}));

export { MaterialUISwitch };
